import { useState, useContext } from "react"
import { api } from "../../../api/api"
import { Toast } from "../../../utils/Toast"
import { DistrictContext } from "../../../context/DistrictContext"
import { mascaraMoeda, maskCurrency } from "../../../utils/utils"
import { GlobalContext } from "../../../context/GlobalContext"
import { FiMapPin, FiSave } from "react-icons/fi"

export function ModalDeliveryDistrict() {
  const { isAccess } = useContext(GlobalContext)

  const { findAll } = useContext(DistrictContext)
  const [state, setState] = useState({
    id: null,
    district: "",
    pricing: 0,
    active: false
  })

  function clear() {
    setState({
      id: null,
      district: "",
      pricing: 0,
      active: false
    })
  }

  async function created(e) {
    if (!isAccess('metodo_entrega', 'create')) {
      return Toast.warning('Você não tem permissão para criar entrega.')
    }

    e.preventDefault()
    const response = await api.post("/delivery-district", state)
    const { id } = response.data
    setState({
      ...state,
      id
    })
    Toast.success()
    clear()
    await findAll()
    return id
  }

  async function updated(e) {
    if (!isAccess('metodo_entrega', 'update')) {
      return Toast.warning('Você não tem permissão para atualizar entrega.')
    }
    e.preventDefault()
    await api.put("/delivery-district", state)
    Toast.success()
    clear()
    await findAll()
  }

  return (
    <>
      <div className="modal fade delivery-district-modal" id="modalDeliveryDistrict" tabIndex="-1" aria-labelledby="deliveryDistrictModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <div className="delivery-district-modal-title"><span><FiMapPin size={18} /></span><div><h2 id="deliveryDistrictModalLabel">Adicionar bairro</h2><p>Informe o bairro e sua taxa de entrega</p></div></div>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Fechar"></button>
            </div>
            <div className="modal-body">
              <form className="delivery-district-form">
                <div className="form-group">
                  <label htmlFor="districtName">Nome do bairro</label>
                  <input type="text"
                    value={state.district} onChange={(e) => setState({
                      ...state,
                      district: e.target.value
                    })}
                    className="form-control"
                    id="districtName"
                    aria-describedby="districtNameHelp"
                  />
                  <small id="districtNameHelp">Digite o nome usado no endereço do cliente.</small>
                </div>
                <div className="form-group">
                  <label htmlFor="districtPricing">Taxa de entrega</label>
                  <input type="text"
                    value={maskCurrency(state.pricing)} onChange={(e) => setState({
                      ...state,
                      pricing: mascaraMoeda(e.target.value)
                    })}
                    className="form-control"
                    id="districtPricing"
                  />
                </div>
                <label className="delivery-district-active">
                  <input type="checkbox" value={state.active} onChange={(e) => setState({
                    ...state,
                    active: e.target.checked
                  })} />
                  Ativar bairro após cadastrar
                </label>
                <button type="submit" className="delivery-district-save" onClick={state.id ? updated : created}><FiSave size={15} /> Salvar bairro</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
